<template>
  <div>
    <b-card :header="$t('settings.header')">
      <b-form @submit.prevent="handleEdit()">
        <h4>
          <p class="text-muted">{{ $t('settings.editAcc') }} {{user.username}}</p>
        </h4>
        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>{{ $t('login.holderUsername') }}</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('login.holderUsername')"
            autocomplete="username"
            v-model="username"
            name="username"
            disabled
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-user"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('settings.name')"
            autocomplete="name"
            v-model="name"
            name="name"
            :class="{ 'is-invalid': submitted && !name }"
          />
          <div v-show="submitted && !name" class="invalid-feedback">{{ $t('settings.nameReq') }}</div>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>@</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            placeholder="Email"
            autocomplete="email"
            v-model="email"
            name="email"
            :class="{ 'is-invalid': submitted && !email }"
          />
          <div v-show="submitted && !email" class="invalid-feedback">{{ $t('settings.emailReq') }}</div>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-map"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('settings.address')"
            autocomplete="address"
            v-model="address"
            name="address"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-envelope"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('settings.contact')"
            autocomplete="contact"
            v-model="contact"
            name="contact"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-phone"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="tel"
            class="form-control"
            :placeholder="$t('settings.primTelNum')"
            autocomplete="telnumber"
            v-model="telNumber1"
            name="telNumber1"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-phone"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="tel"
            class="form-control"
            :placeholder="$t('settings.secTelNum')"
            autocomplete="telnumber"
            v-model="telNumber2"
            name="telNumber2"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-key"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('settings.ico')"
            autocomplete="ico"
            v-model="ico"
            name="ico"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="icon-key"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            class="form-control"
            :placeholder="$t('settings.dic')"
            autocomplete="dic"
            v-model="dic"
            name="dic"
          />
        </b-input-group>

        <div v-if="errored" class="alert alert-danger">{{errored}}</div>
        <div v-if="informed" class="alert alert-success">{{informed}}</div>

        <b-button variant="success" type="submit" :disabled="loading" block>{{ $t('settings.subEdit') }}</b-button>
      </b-form>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-password variant="info">{{ $t('settings.changePass') }}</b-button>
      </b-card-header>
      <b-collapse id="accordion-password" accordion="accordion-password">
        <b-card-body>
          <b-form @submit.prevent="handleChangePassword()">
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                class="form-control"
                :placeholder="$t('settings.oldPass')"
                autocomplete="old-password"
                v-model="oldPassword"
                name="password"
                :class="{ 'is-invalid': submitted && !oldPassword }"
              />
              <div
                v-show="submitted && !oldPassword"
                class="invalid-feedback"
              >{{ $t('settings.oldPassReq') }}</div>
            </b-input-group>

            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                class="form-control"
                :placeholder="$t('settings.newPass')"
                autocomplete="new-password"
                v-model="newPassword1"
                name="password"
                :class="{ 'is-invalid': submitted && !newPassword1 }"
              />
              <div
                v-show="submitted && !newPassword1"
                class="invalid-feedback"
              >{{ $t('settings.newPassReq') }}</div>
            </b-input-group>

            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                class="form-control"
                :placeholder="$t('settings.newPassConf')"
                autocomplete="new-password"
                v-model="newPassword2"
                name="password"
                :class="{ 'is-invalid': submitted && (!newPassword2 || newPassword1 !== newPassword2) }"
              />
              <div
                v-show="submitted && !newPassword2"
                class="invalid-feedback"
              >{{ $t('settings.newPassConfReq') }}</div>
              <div
                v-show="submitted && newPassword1 !== newPassword2"
                class="invalid-feedback"
              >{{ $t('settings.passErr') }}</div>
            </b-input-group>

            <div v-if="passInfo" class="alert alert-success">{{passInfo}}</div>
            <div v-if="passError" class="alert alert-danger">{{passError}}</div>

            <b-button
              variant="outline-success"
              type="submit"
              :disabled="loading"
              block
            >{{ $t('settings.confPassChange') }}</b-button>
          </b-form>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { router } from "@/router";
import { userService } from "@/_services";
import { errorHandler } from "@/_helpers";

export default {
  name: "Settings",
  data() {
    return {
      user: {},
      data: "",
      username: "",
      name: "",
      email: "",
      address: "",
      contact: "",
      telNumber1: "",
      telNumber2: "",
      ico: "",
      dic: "",
      submitted: false,
      loading: true,
      errored: "",
      informed: "",
      oldPassword: "",
      newPassword1: "",
      newPassword2: "",
      passInfo: "",
      passError: ""
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("viewer-user"));

    userService
      .getUser(this.user.username)
      .then(response => {
        this.data = response.data;
        this.username = response.data.username;
        this.name = response.data.fullname;
        this.email = response.data.email;
        this.address = response.data.address;
        this.contact = response.data.contact;
        this.telNumber1 = response.data.tellnumber1;
        this.telNumber2 = response.data.tellnumber2;
        this.ico = response.data.ico;
        this.dic = response.data.dic;

        this.loading = false;
      })
      .catch(error => {
        this.errored = errorHandler(error);
      });
  },
  methods: {
    handleChangePassword() {
      this.submitted = true;
      this.passInfo = null;
      this.passError = null;
      const { data, oldPassword, newPassword1, newPassword2 } = this;

      if (
        !(oldPassword && newPassword1 && newPassword2) ||
        newPassword1 !== newPassword2
      ) {
        return;
      }

      this.loading = true;
      var redirect = false;
      userService
        .changePassword(data.id, oldPassword, newPassword1)
        .then(() => {
          this.passInfo = this.$i18n.t('settings.succPassChange');
          redirect = true;
        })
        .catch(error => {
          this.passError = errorHandler(error);
        })
        .finally(() => {
          if (redirect) {
            setTimeout(() => {
              router.push("/login");
            }, 2000);
          } else {
            this.submitted = false;
            this.loading = false;
          }
        });
    },
    handleEdit() {
      this.submitted = true;
      this.informed = null;
      this.errored = null;
      const {
        data,
        name,
        email,
        address,
        contact,
        telNumber1,
        telNumber2,
        ico,
        dic
      } = this;

      // stop here if form is invalid
      if (!(name && email)) {
        return;
      }

      // stop here if no changes are made
      if (
        data.fullname === name &&
        data.email === email &&
        data.address === address &&
        data.contact === contact &&
        data.tellnumber1 === telNumber1 &&
        data.tellnumber2 === telNumber2 &&
        data.ico === ico &&
        data.dic === dic
      ) {
        this.informed = this.$i18n.t('settings.noChanges');
        return;
      }

      var jsonData = JSON.stringify({
        name,
        email,
        address,
        contact,
        telNumber1,
        telNumber2,
        ico,
        dic
      });

      this.loading = true;
      userService
        .editUser(data.id, jsonData)
        .then(response => {
          this.informed = this.$i18n.t('settings.accSuccUpdate');
          this.data = response.data;
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
        .finally(() => {
          this.submitted = false;
          this.loading = false;
        });
    }
  }
};
</script>